import React from "react";
import { Modal, CloseButton, Row, Col } from "react-bootstrap";
import styles from "./responsiveModal.module.scss";

interface IResponsiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  headerLeft: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  dialogClassName?: string;
  contentClassName?: string;
  headerClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
}

const ResponsiveModal: React.FC<IResponsiveModalProps> = ({
  isOpen,
  onClose,
  headerLeft,
  children,
  footer,
  dialogClassName = "",
  contentClassName = "",
  headerClassName = "",
  bodyClassName = "",
  footerClassName = "",
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      scrollable
      fullscreen="md-down"
      className={`p-0 ${styles.responsiveModal}`}
      style={{ bottom: "var(--app-bottom-offset)" }}
      backdropClassName="z-1"
      dialogClassName={dialogClassName}
      contentClassName={` ${contentClassName}`}
    >
      <Modal.Header
        className={`border-0 p-4 w-100 d-flex justify-content-between align-items-center ${headerClassName}`}
      >
        <Row className="w-100 gx-2 align-items-start">
          <Col className="min-w-0">{headerLeft}</Col>
          <Col xs="auto" className="d-flex justify-content-end">
            <CloseButton className="py-3 px-0" onClick={onClose} />
          </Col>
        </Row>
      </Modal.Header>

      <Modal.Body className={`overflow-y-auto ${bodyClassName}`}>
        {children}
      </Modal.Body>
      {footer ? (
        <Modal.Footer
          className={`py-4 pt-md-5 border-0 px-5 px-md-4 ${footerClassName}`}
        >
          {footer}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default React.memo(ResponsiveModal);
